import React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="study-shell flex min-h-screen w-full flex-col bg-[color:var(--wf-paper-deep)] text-[color:var(--wf-ink)]">
      <NavBar />
      <main className="flex w-full flex-grow flex-col items-center pt-20">
        <div className="w-full max-w-6xl px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
